<template>
    <div class="container-fluid">

        <div class="row">
            <div class="col">
                <h2 class="checkout-h2">Winkelmandje</h2>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-lg-6 col-xl-7">
                <div class="cart__item_wrapper" style="display: block" v-for="(item, index) in items.products"  v-bind:key="index">
                    <checkout-item :item="item"></checkout-item>
                </div>
                <div class="mt-5 checkout-btn-section">
                    <router-link :to="{name: 'categories'}" class="btn btn-primary">Nog 1 toevoegen</router-link>
                    <router-link :to="{name: 'contact'}" class="btn">Afronden</router-link>
                </div>

            </div>
            <div class="col-lg-1 d-none d-lg-flex d-xl-none"></div>
            <div class="col-12 col-lg-5 right_static">
                <div>
                    <h4>Hebt u een vraag?</h4>
                    <h4>Wij helpen u graag!</h4><br>
                    <p><strong>U kunt ons steeds bereiken op:</strong></p>
                    <ul>
                        <li><a href="tel:033037900">03 303 79 00</a></li>
                        <li><a href="tel:011494333">011 49 43 33</a></li>
                        <li><span>nu open</span></li>
                    </ul>
                    <p><strong>Mailen</strong> kan naar&nbsp;<a href="mailto:info@straalstudio.be">info@straalstudio.be</a></p>

                    <p>Heeft u nog andere vragen? <br><strong><a href="https://straalstudio.be/contact" target="_blank">Stel ze hier</a> !</strong></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Item from './Item'

    export default {
        name: "Checkout",

        components: {
            'checkout-item': Item
        },

        data() {
            return {
                items: {
                    products: [],
                }
            }
        },

        methods: {
            getItems() {
                this.items.products = JSON.parse(localStorage.getItem('products'));
            },
        },

        mounted() {
            this.$root.$on('fetch-cart-items', () => {
                this.getItems();
            });

            this.getItems()
        }
    }
</script>

<style scoped lang="scss">
    .checkout-h2 {
        font-size: 1.7rem;
        margin-bottom: 20px;
        text-align: center;
        font-weight: 500;
        @media (min-width: 992px) {
            font-size: 2rem;
            text-align: left;
        }
        @media (min-width: 1200px) {
            font-size: 2.4rem;
        }
    }

    .checkout-btn-section {
        .btn {
            padding: 12px 22px;
            border: 1px solid white;
            text-transform: uppercase;
            border-radius: 0;
            color: white;
            text-decoration: none;
            -webkit-transition: all 0.25s ease;
            transition: all 0.25s ease;
            margin: 0 auto;
            margin-bottom: 20px;
            display: block;
            &:hover {
                background: white;
                color: black;
            }
            @media (min-width: 768px){
                display: inline-block;
                padding: 20px 30px;
                margin-right: 20px;
                &:hover {
                    background: white;
                    color: black;
                }   
            }
        }
    }

    .cart__item_wrapper {
        text-align: left;
        > div {
            text-transform: uppercase;
            padding: 20px 20px 10px;
            border-bottom: 1px solid white;
            @media (min-width: 600px){
                padding: 25px 30px;
            }
        }
    }

    .right_static {
        color: white;
        margin-top: 60px;
        @media (min-width: 992px){
            margin-top: 0;
        }
        @media (min-width: 1201px){
            position: absolute;
            right: 0;
            width: 350px;
        }
        @media (min-width: 1400px){
            position: absolute;
            right: -100px;
        }
        h4 {
            text-transform: uppercase;
        }
        p {
            font-weight: 300;
        }
        ul {
            margin: 0;
            margin-bottom: 1rem;
            padding: 0;
            list-style: none;
            li {
                font-weight: 300;
                a, a:hover {
                    text-decoration: none;
                }
                span {
                    background: white;
                    margin-top: 5px;
                    padding: 4px 10px;
                    display: inline-block;
                    color: black;
                }
            }
        }
        a {
            color: white;
        }
    }

</style>
